export enum PricingCodesCategorySubCategory {
  PricingApp = 'PricingApp',
  Security = 'Security',
}
